export default __webpack_public_path__ + "static/media/copy-black.71cddb4a.svg";